import { Card, Stack, Inline, Heading, Box } from 'braid-design-system';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  heading?: string;
}

export const PageSection = ({ children, heading }: Props) => (
  <Card>
    <>
      <Stack space="small">
        <Inline alignY="bottom" space="xxsmall">
          {heading ? <Heading level="3">{heading}</Heading> : null}
        </Inline>
      </Stack>
      <Box marginBottom={heading ? 'large' : 'none'} />
      {children}
    </>
  </Card>
);
